import { useContext, useEffect, useState } from 'react'
import { parseCookies, setCookie } from 'nookies'
import router from 'next/router'
import MobileDetect from 'mobile-detect'
import * as customerApi from '@api/customer/customer'
import { AuthorizeContext } from '@context/AuthorizeState'
import * as customerModel from '@entities/customer/model'
import { customerLogout } from '@entities/customer/model'
import { AlertsStateContext } from '@context/AlertsState'
import { useMergeFavorites } from 'src/features/favorite/model/favorite-storage'
import { useEvent, useUnit } from 'effector-react'
import { $authForPage, successAuth } from 'src/features/authorize/start'
import { setIsAuthorization } from '@entities/authorization/model'

const smsTimeout = 60

export const useAuthorize = (isStartSendSms = false) => {
    const authorizeContext = useContext(AuthorizeContext)
    const logout = useEvent(customerLogout)
    const success = useUnit(successAuth)
    const successAuthorization = useUnit(setIsAuthorization)
    const authForPage = useUnit($authForPage)
    const { confirmCustomer } = useContext(AlertsStateContext)
    const [isSendSms, setIsSendSms] = useState(isStartSendSms)
    const [phoneNumber, setPhoneNumber] = useState('')
    const [code, setCode] = useState('')
    const [errorText, setErrorText] = useState('')
    const [deviceId, setDeviceId] = useState('')
    const [isShowedSubmitSmsWindow, setIsShowedSubmitSmsWindow] = useState(isStartSendSms)
    const toggleShowedSubmitSmsWindow = () => setIsShowedSubmitSmsWindow(!isShowedSubmitSmsWindow)
    const [timer, setTimer] = useState({
        seconds: smsTimeout,
        isActive: false
    })
    const mergeFavorites = useMergeFavorites()

    useEffect(() => {
        let interval = null
        if (timer.isActive) {
            interval = setInterval(() => {
                if (timer.seconds < 1) {
                    setTimer({ ...timer, seconds: 0, isActive: false })
                } else {
                    setTimer({ ...timer, seconds: timer.seconds - 1 })
                }
            }, 1000)
        } else if (!timer.isActive && timer.seconds !== 0) {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [timer])

    const submitPhone = async () => {
        const cookies = parseCookies()
        const isAuthorization = await customerApi.checkAuthorization()
        if (isAuthorization) {
            success()
            if (authorizeContext.isRedirectLk) {
                await router.push('/account/history')
                return
            }
            return
        }
        const response = await customerApi.confirmCustomer({
            phone: phoneNumber.replace(/\D+/g, ''),
            deviceId: cookies.deviceId || null,
            term: 2
        })

        if (response.isTimeout) {
            setTimer({
                ...timer,
                seconds: smsTimeout,
                isActive: true
            })
            return
        }

        if (!response.deviceId) throw new Error(`Ошибка! нету deviceId при регистрации ${JSON.stringify(response)} `)
        setCookie(null, 'deviceId', response.deviceId, {
            maxAge: 360 * 24 * 60 * 60,
            path: '/'
        })
        setDeviceId(response.deviceId)
        setIsSendSms(true)
        setTimer({
            ...timer,
            seconds: smsTimeout,
            isActive: true
        })
        setIsShowedSubmitSmsWindow(true)
    }

    // eslint-disable-next-line consistent-return
    const registrationCustomer = async (submitCode, isReload) => {
        const response = await customerApi.createCustomer({
            deviceId,
            phone: phoneNumber.replace(/\D+/g, ''),
            code: submitCode
        })
        if (response.statusType !== 1) {
            console.error(`Ошибка регистрации ${JSON.stringify(response)}`)
            if (response.statusType === 3) {
                setErrorText('Неверный код. Попробуйте еще раз')
                setCode('')
            }
            if (response.statusType === 2) {
                setErrorText('Превышено число попыток')
            }
            if (response.statusType === 5) {
                setErrorText('Вы недавно отправляли запрос, пожалуйста попробуйте позже')
            }
            return false
        }
        if (response.token) {
            setCookie({}, 'customer_token', response.token, {
                maxAge: 365 * 24 * 60 * 60,
                path: '/'
            })
            await customerModel.effects.getCustomerProfileFx()
            authorizeContext.toggleIsOpen()
            confirmCustomer.toggleClose()

            setIsSendSms(false)
            setIsShowedSubmitSmsWindow(false)
            mergeFavorites()
            const ua = window.navigator.userAgent
            const md = new MobileDetect(ua)
            const isMobile = !!md.mobile()
            if (authForPage.redirectUrl) {
                successAuthorization()
                success()
                return
            }
            if (!isMobile) {
                successAuthorization()
                if (isReload) {
                    router.reload()
                } else if (authorizeContext.isRedirectLk) await router.push('/account/history')
            }
            //TODO: merge liked
        }
    }

    const changeCodeSubmit = async (e, isReload = false) => {
        setCode(e.target.value)
        setErrorText('')
        if (e.target.value && e.target.value.length === 4) {
            await registrationCustomer(e.target.value, isReload)
        }
    }
    // eslint-disable-next-line consistent-return,no-shadow
    const sendConde = async (code) => {
        setCode(code)
        setErrorText('')
        if (code && code.length === 4) {
            // eslint-disable-next-line no-return-await
            return await registrationCustomer(code)
        }
    }
    const selectInputPhonePage = () => {
        setIsSendSms(false)
    }

    return {
        isSendSms,
        phoneNumber,
        setPhoneNumber,
        errorText,
        timer,
        code,
        isShowedSubmitSmsWindow,
        toggleShowedSubmitSmsWindow,
        sendConde,
        submitPhone,
        changeCodeSubmit,
        selectInputPhonePage
    }
}
export const useChangePhone = () => {
    const [isSendSms, setIsSendSms] = useState(false)
    const [phoneNumber, setPhoneNumber] = useState('')
    const [code, setCode] = useState('')
    const [errorText, setErrorText] = useState('')
    const [isShowedSubmitSmsWindow, setIsShowedSubmitSmsWindow] = useState(false)
    const toggleShowedSubmitSmsWindow = () => setIsShowedSubmitSmsWindow(!isShowedSubmitSmsWindow)
    const [timer, setTimer] = useState({
        seconds: smsTimeout,
        isActive: false
    })

    useEffect(() => {
        let interval = null
        if (timer.isActive) {
            interval = setInterval(() => {
                if (timer.seconds < 1) {
                    setTimer({ ...timer, seconds: 0, isActive: false })
                } else {
                    setTimer({ ...timer, seconds: timer.seconds - 1 })
                }
            }, 1000)
        } else if (!timer.isActive && timer.seconds !== 0) {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [timer, timer.isActive, timer.seconds])

    const submitPhone = async () => {
        setErrorText('')
        const response = await customerApi.profileConfirmChangePhone(phoneNumber.replace(/\D+/g, ''))
        if (response.status === 4) {
            setTimer({
                ...timer,
                seconds: smsTimeout,
                isActive: true
            })
        }
        if (response.status !== 5) {
            setErrorText(response.message)
            return
        }
        setIsSendSms(true)
        setIsShowedSubmitSmsWindow(true)
        setTimer({
            ...timer,
            seconds: smsTimeout,
            isActive: true
        })
    }

    const sendConde = async (submitCode) => {
        const response = await customerApi.profileChangePhone(phoneNumber.replace(/\D+/g, ''), submitCode)
        if (response.status === 0) {
            successAuthorization()
            await router.reload()
            return
        }
        if (response.status !== 0) {
            setErrorText(response.message)
            setCode('')
        }
        if (response.status !== 1) {
            if (response.status === 3) {
                setErrorText('Неверный код. Попробуйте еще раз')
                setCode('')
            }
            if (response.status === 2) {
                setErrorText('Превышено число попыток')
            }
            if (response.status === 5) {
                setErrorText('Вы недавно отправляли запрос, пожалуйста попробуйте позже')
            }
        }
    }

    const changeCodeSubmit = async (e) => {
        setCode(e.target.value)
        setErrorText('')
        if (e.target.value && e.target.value.length === 4) {
            await sendConde(e.target.value)
        }
    }
    const selectInputPhonePage = () => {
        setIsSendSms(false)
        setIsShowedSubmitSmsWindow(false)
    }

    return {
        isSendSms,
        phoneNumber,
        setPhoneNumber,
        errorText,
        timer,
        code,
        isShowedSubmitSmsWindow,
        toggleShowedSubmitSmsWindow,
        sendConde,
        submitPhone,
        changeCodeSubmit,
        selectInputPhonePage
    }
}
